/* unplugin-vue-components disabled */import { render } from "./medicationGuidance.vue?vue&type=template&id=7af470ce&scoped=true"
import script from "./medicationGuidance.vue?vue&type=script&lang=js"
export * from "./medicationGuidance.vue?vue&type=script&lang=js"

import "./medicationGuidance.vue?vue&type=style&index=0&id=7af470ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af470ce"]])

export default __exports__